export default "__VITE_ASSET__n$NGtGlx__"